// MenuItem component to display individual menu items
import settingsService from '../../config/settingsService';
import FallbackImg from '../FallbackImg';
import SpiceLevel from '../SpiceLevel';

// Same guard RestaurantMenuApp's own ProductCard uses
// (product.isVeg !== undefined) — items whose source data never carried
// veg/non-veg info render nothing, rather than a misleading dot.
const VegNonVegBadge = ({ isVeg }) => {
  if (isVeg === undefined) return null;
  return (
    <div className="menu-section__veg-badge-wrap">
      <div className="menu-section__veg-badge">
        <div className={isVeg ? 'menu-section__veg-dot' : 'menu-section__non-veg-dot'}></div>
      </div>
    </div>
  );
};

const MenuItem = ({ name, description, price, image, isVeg, spiceLevel }) => {
  // Format price with dynamic currency from settingsService
  const formattedPrice = settingsService.formatPrice(price);

  // Check if image is valid (not empty, not placeholder)
  const hasValidImage = image &&
    image !== '' &&
    !image.includes('via.placeholder.com') &&
    image !== 'null' &&
    image !== 'undefined';

  const displayImage = hasValidImage ? image : null;

  return (
    <div className="offer-item">
      <VegNonVegBadge isVeg={isVeg} />
      <FallbackImg
        src={displayImage}
        alt={name || 'Menu item'}
        className="img-responsive"
      />
      <div>
        <h3>{name}</h3>
        {spiceLevel > 0 && <SpiceLevel level={spiceLevel} size={12} />}
        {description && <p>{description}</p>}
      </div>
      <span className="offer-price">{formattedPrice}</span>
    </div>
  );
};
export default MenuItem;